import { type FC, useMemo } from "react";
import { useFormatGoalAmount } from "web_myplann/Goals/Helpers/formatGoalAmount";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationColdIntro } from "web_myplann/Inspiration/Components/InspirationColdIntro";
import { InspirationExampleText } from "web_myplann/Inspiration/Components/InspirationExampleText";
import { InspirationStatCardList } from "web_myplann/Inspiration/Components/InspirationStatCardList";
import { getEarlyFreedomExample } from "web_myplann/Inspiration/EarlyFreedom/Utils/getEarlyFreedomExample";
import { useInspirationMoney } from "web_myplann/Inspiration/Hooks/useInspirationMoney";
import { INSPIRATION_CURRENCY } from "web_myplann/Inspiration/Utils/inspirationMoney";

const R = Resources.Inspiration.EarlyFreedom;

export const EarlyFreedomColdIntro: FC = () => {
	const example = useMemo(getEarlyFreedomExample, []);
	const money = useInspirationMoney();
	const formatAmount = useFormatGoalAmount();
	const capitalInText = formatAmount(example.capital, INSPIRATION_CURRENCY, {
		millionsUnit: "word",
	});
	const capitalOnCard = formatAmount(example.capital, INSPIRATION_CURRENCY, {
		millionsUnit: "letter",
	});

	return (
		<InspirationColdIntro
			intro={R.intro}
			exampleTitle={R.exampleTitle}
			exampleHint={R.exampleHint}
		>
			<InspirationExampleText
				text={R.exampleBody}
				values={{
					spend: money(example.spend),
					rent: money(example.rent),
					gap: money(example.gap),
					capital: capitalInText,
				}}
			/>

			<InspirationStatCardList
				stats={[
					{
						label: R.exampleTodayLabel,
						amount: money(example.rent),
						tone: "neutral",
					},
					{
						label: R.exampleNeedLabel,
						amount: `~${capitalOnCard}`,
						tone: "highlight",
					},
				]}
			/>
		</InspirationColdIntro>
	);
};
